<template>
  <div>
		<h2>
			<span class="form-group">
				Reproduction Planning
				<comments field-name='heading_reproduction_planning' :isReadOnly="isReadOnly"></comments>
			</span>
		</h2>
		<hr>
		<div class="alert alert-success text-center">
			Most of this step is optional. Required fields are surrounded with red boxes.
		</div>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields mandatory-fields" :key="farm.id">
        <h3>
          <span class="form-group">
              {{ farm.farm_label }}
              <comments field-name="heading_farm_label" :farm-id="farm.id" :isReadOnly="isReadOnly"></comments>
          </span>
        </h3>

        <date-input label="Planned Start of Calving - Herd"
                    field-name="start_calving_herd"
                    :farm-id="farm.id"
                    :disabled="isReadOnly">
        </date-input>

        <date-input label="Planned Start of Calving - Heifers"
                    field-name="start_calving_heifers"
                    :farm-id="farm.id"
                    :disabled="isReadOnly">
        </date-input>

        <date-input label="Planned Start of Mating - Herd"
                    field-name="start_mating_herd"
                    :farm-id="farm.id"
                    :disabled="isReadOnly">
        </date-input>

        <date-input label="Planned Start of Mating - Heifers"
                    field-name="start_mating_heifers"
                    :farm-id="farm.id"
                    :disabled="isReadOnly">
        </date-input>

      </div>
    </div>

    <div class="step-section">
      <h3>Dairy Metricheck/Metriclean Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Date</th>
            <th>Product</th>
            <th>Cows</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in getChartData('metri_checked_cleaned_table')" :key="index"
            :class="getRowClass(getChartData('metri_checked_cleaned_table'), 'Season', index)">

            <td class="text-left">{{ rv["Season"] }}</td>
            <td class="text-left">{{ rv["Date"] }}</td>
            <td class="text-left">{{ rv["Product"] }}</td>
            <td class="text-left">{{ rv["Cows"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="clearfix" :style="{ width: widthForRow(FARMS) + 'px' }">
      <div v-for="farm in FARMS" class="farm-fields" :key="farm.id">
        <fieldset>
          <legend>
            <p class="form-group">
            Planned Metrichecking
            <br>
            {{farm.farm_label}}
            <comments field-name="heading_planned_metrichecking" :farm-id="farm.id" :isReadOnly="isReadOnly"></comments>
            </p>
          </legend>

          <radio-input label="First"
                       field-name="metri_check_1"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <date-input label="First Est. Date"
                      field-name="metri_check_date_1"
                      :farm-id="farm.id"
                      :disabled="isReadOnly">
          </date-input>

          <radio-input label="Second"
                       field-name="metri_check_2"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <date-input label="Second Est. Date"
                      field-name="metri_check_date_2"
                      :farm-id="farm.id"
                      :disabled="isReadOnly">
          </date-input>


          <radio-input label="Third"
                       field-name="metri_check_3"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <date-input label="Third Est. Date"
                      field-name="metri_check_date_3"
                      :farm-id="farm.id"
                      :disabled="isReadOnly">
          </date-input>

        </fieldset>


        <radio-input label="Do you want a reproduction consult or mating planning?"
                     field-name="wants_repro_consult"
                     :farm-id="farm.id"
                     :choices="[
                                {value: 'Yes', display: 'Yes'},
                                {value: 'No', display: 'No'},
                                {value: 'Maybe', display: 'Maybe'},
                                ]"
                     :disabled="isReadOnly">
        </radio-input>

        <fieldset>
          <legend>
            <p class="form-group">
            Reproduction Programs
            <br>
            {{farm.farm_label}}
            <comments :field-name="`farm_${farm.id}-heading_reproduction_programs`" :isReadOnly="isReadOnly"></comments>
            </p>
          </legend>

          <radio-input label="Cow Sync PG?"
                       field-name="cow_sync_pg"
                       :farm-id="farm.id"
                       :choices="[
                                 {value: 'Yes', display: 'Yes'},
                                 {value: 'No', display: 'No'},
                                 {value: 'Maybe', display: 'Maybe'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Heifer Sync CIDR?"
                       field-name="heifer_sync_qmate_cidr"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Heifer Sync PG?"
                       field-name="heifer_sync_pg"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Bull fertility testing"
                       field-name="bull_fertility_test"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

        </fieldset>

      </div>
    </div>

    <section>
      <h3>
        <span class="form-group">
          CIDR Inserts Detail
          <comments field-name='heading_cuemate_cidr' :isReadOnly="isReadOnly"></comments>
        </span>
      </h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Date</th>
            <th>Product</th>
            <th>Cows Treated</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in getChartData('cuemate_cidr_table')" :key="'cuemate_cidr_table_'+index"
            :class="getRowClass(getChartData('cuemate_cidr_table'), 'Season', index)">

            <td class="text-left">{{ rv["Season"] }}</td>
            <td class="text-left">{{ rv["Date"] }}</td>
            <td class="text-left">{{ rv["Product"] }}</td>
            <td class="text-left">{{ rv["Cows"] }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <div class="clearfix" :style="{ width: widthForRow(getFieldValue('FARMS')) + 'px' }">
      <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
        <fieldset>
            <legend>
              <p class="form-group">
              Non-Cyclers
              <br>
              {{farm.farm_label}}
              <comments :field-name="`farm_${farm.id}-heading_non_cyclers`" :isReadOnly="isReadOnly"></comments>
              </p>
            </legend>

            <radio-input label="Non-cyclers First"
                       field-name="non_cyclers_1"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <date-input label="First Est. Date"
                      field-name="non_cyclers_1_date"
                      :farm-id="farm.id"
                      :disabled="isReadOnly">
          </date-input>


          <radio-input label="Non-cyclers Second"
                       field-name="non_cyclers_2"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <date-input label="Second Est. Date"
                      field-name="non_cyclers_2_date"
                      :farm-id="farm.id"
                      :disabled="isReadOnly">
          </date-input>


          <radio-input label="Non-cyclers Third"
                       field-name="non_cyclers_3"
                       :farm-id="farm.id"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  {value: 'Maybe', display: 'Maybe'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <date-input label="Third Est. Date"
                      field-name="non_cyclers_3_date"
                      :farm-id="farm.id"
                      :disabled="isReadOnly">
          </date-input>
        </fieldset>
      </div>
    </div>

    <div class="non_cycling_exam-chart" v-if="hasNonCyclingExamData">
        <bar :chart-data="nonCyclingExamData" :options="nonCyclingExamOptions"></bar>
    </div>


    <h3 class="text-left">
      <span class="form-group">
          Cow Pregnancy Scan Review
          <comments field-name='heading_cow_pregnancy_scan_review' :isReadOnly="isReadOnly"></comments>
      </span>
    </h3>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Date</th>
          <th>Product</th>
          <th>Quantity Purchased</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(psr, index) in getChartData('pregnancy_scan_review')" :key="index">
          <td class="text-left">{{ psr['Date'] }}</td>
          <td class="text-left">{{ psr['Product'] }}</td>
          <td class="text-left">{{ psr['Quantity Purchased'] }}</td>
        </tr>
      </tbody>
    </table>

    <div class="clearfix" :style="{ width: widthForRow(FARMS) + 'px' }">
      <div v-for="farm in FARMS" class="farm-fields" :key="farm.id">
        <fieldset>
          <legend>
            <p class="form-group">
            Pregnancy Scanning
            <br>
            {{farm.farm_label}}
            <comments field-name="heading_pregnancy_scanning" :farm-id="farm.id" :isReadOnly="isReadOnly">
            </comments>
            </p>
          </legend>

          <radio-input label="Pregnancy Scan with VetSouth?"
                       field-name="preg_scan_with_vs"
                       :farm-id="farm.id"
                       :choices="[
                                 {value: 'Yes', display: 'Yes'},
                                 {value: 'No', display: 'No'},
                                 {value: 'Maybe', display: 'Maybe'},
                                 ]"
                       :disabled="isReadOnly">
          </radio-input>

          <h3>
            Herd Scan
          </h3>

          <check-box label="Early aged"
                     field-name="wants_preg_scan_herd_early_aged"
                     :farm-id="farm.id"
                     :disabled="isReadOnly">
          </check-box>

          <check-box label="Late aged single scan"
                     field-name="wants_preg_scan_herd_late_aged_single"
                     :farm-id="farm.id"
                     :disabled="isReadOnly">
          </check-box>
          <check-box label="Y/N May scan"
                     field-name="wants_preg_scan_herd_yn_may"
                     :farm-id="farm.id"
                     :disabled="isReadOnly">
          </check-box>

          <h3>
            Heifer Scan
          </h3>

          <check-box label="Aged scan"
                     field-name="wants_preg_scan_hef_aged"
                     :farm-id="farm.id"
                     :disabled="isReadOnly">
          </check-box>

          <check-box label="Recheck scan"
                     field-name="wants_preg_scan_hef_recheck"
                     :farm-id="farm.id"
                     :disabled="isReadOnly">
          </check-box>
          <check-box label="Y/N May scan"
                     field-name="wants_preg_scan_hef_yn_may"
                     :farm-id="farm.id"
                     :disabled="isReadOnly">
          </check-box>
        </fieldset>

				<div class="mandatory-fields">
						<fieldset>
						<div :class="{fonterraFields: isFonterraClient && isFonterraFarm()(farm.id)}">
							<legend>
								<p class="form-group">
									In-calf Rates <br>
									{{farm.farm_label}}
									<comments :field-name="`farm_${farm.id}-heading_incalf_rates`" :isReadOnly="isReadOnly"></comments>
								</p>
							</legend>

							<hr>
							<discussion-points title=""
								:comments-field="`farm_${farm.id}-cd_icr_plan_discussion_points`"
								points="Industry targets: 3wk ICR 54%, 6wk ICR 78%, 9wk NICR 10%; Treating NCC, Bulls vs AI, synching heifers/herd, transition management, nutrition, use of technology">
							</discussion-points>
							<hr>

							<number-input label="3 Week ICR (%) - Target 54%"
								field-name="incalf_three_week"
								:is-float="true"
								:farm-id="farm.id"
								:disabled="isReadOnly">
							</number-input>

							<number-input label="6 Week ICR (%) - Target 78%"
								field-name="incalf_six_week"
								:is-float="true"
								:farm-id="farm.id"
								:disabled="isReadOnly">
							</number-input>

							<number-input label="NICR (%) - Target 10%"
								field-name="incalf_empty"
								:is-float="true"
								:farm-id="farm.id"
								:disabled="isReadOnly">
							</number-input>
						</div>

							<number-input label="Length Mating - AI (days)"
								field-name="length_mating_ai"
								:farm-id="farm.id"
								:disabled="isReadOnly">
							</number-input>

							<number-input label="Length Mating - Bulls (days)"
								field-name="length_mating_bulls"
								:farm-id="farm.id"
								:disabled="isReadOnly">
							</number-input>

							<number-input label="Total Length Mating (days)"
								field-name="length_mating_total"
								:farm-id="farm.id"
								:disabled="isReadOnly">
							</number-input>

						</fieldset>
				</div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import Bar from '../charts/Bar'
import { mapGetters } from 'vuex';

export default {
    name: 'ReproductionPlanning',
    mixins: [ baseComponent ],
    components: {
        Bar,
    },
		methods: {
			...mapGetters('currentConsult', ['isFonterraFarm']),
		},
    computed: {
			...mapGetters('currentConsult', [
				'isFonterraClient',
			]),
      cuemateCidrOptions: function () {
          return {
              title: {
                  display: true,
                  text: 'CIDR Inserts Summary',
                  fontSize: 22,
              },
              scales: {
                  yAxes: [{
                      ticks: {
                          beginAtZero: true
                      }
                  }]
              }
          }
      },
      hasCumeateCidrExamData: function () {
        return this.getChartData('cuemate_cidr').length > 0;
      },
      cuemateCidrData: function () {
          return {
              labels: this.getChartData('cuemate_cidr').map( row => row['Season']).reverse(),
              datasets: [
                  {
                      label: "CIDR cows treated as a percent of total cows wintered",
                      backgroundColor: this.getChartData('cuemate_cidr').map(() => "#3e95cd"),
                      data: this.getChartData('cuemate_cidr').map(row => parseFloat((row['Percent of TCW'] || '').replace('%', ''))).reverse(),
                  },
              ],
          }
      },
      nonCyclingExamOptions: function () {
          return {
              legend: { display: false },
              title: {
                  display: true,
                  text: 'Dairy Cow Non-Cycling Exam'
              }
          }
      },
      hasNonCyclingExamData: function () {
        return this.getChartData('non_cycling_exam').length > 0;
      },
      nonCyclingExamData: function () {
          return {
              labels: this.getChartData('non_cycling_exam').map( row => row[0] + ' ' + row[3]).reverse(),
              datasets: [
                  {
                      label: "Dairy Cow Non-Cycling Exam",
                      backgroundColor: this.getChartData('non_cycling_exam').map(() => "#c45850"),
                      data: this.getChartData('non_cycling_exam').map(row => parseFloat((row[4] || ''))).reverse(),
                  },
              ],
          }
      },
      metricheckOptions: function () {
          return {
              title: {
                  display: true,
                  text: '',
              }
          }
      },
    },
};
</script>

<style>
.farm-fields {
    float: left;
    width: 350px;
    margin-right: 3em;
}
.mandatory-fields {
	border: 2px solid rgba(255, 0, 0, .7);
	border-radius: 5px;
}
</style>
